
// Get sitefinder widget data
window.addEventListener( 'message', function ( event ) {
    var data = event.data || {};
    if ( data.type !== 'sfWidgetMessage' || ! data.url )
        return;
    
    if ( data.getParams && Object.keys( data.getParams ).length > 0 ) {
        const queryString = new URLSearchParams( data.getParams ).toString();
        const targetUrl = snJS.sitefinderPageUrl + '?' + queryString;

        window.location.href = targetUrl;
    }
});


// Update sitefinder with widget data
window.addEventListener( 'DOMContentLoaded', () => {
    const iframe = document.querySelector( 'iframe.sitefinder' );
    if ( ! iframe )
        return;

    const originalSrc = iframe.getAttribute( 'src' ) || iframe.dataset.src;

    if ( ! originalSrc )
        return;

    const languageCode = document.documentElement.lang.substring( 0, 2 ).toLowerCase() || 'en';
    const localizedSrc = originalSrc.replace( /\/frontend\/[^/]+/, `/frontend/${languageCode}` );

    iframe.dataset.src = localizedSrc;

    if ( iframe.getAttribute( 'src' ) )
        iframe.src = localizedSrc;

    const hasParams = window.location.search && window.location.search.length > 1;
    if ( ! hasParams )
        return;
    

    const params = new URLSearchParams( window.location.search );
    const paramString = params.toString();

    // Stelle sicher, dass src nicht mit / endet
    const baseSrc = localizedSrc.replace( /\/+$/, '' );

    const newSrc = `${baseSrc}/dispatch/?${paramString}`;

    iframe.dataset.src = newSrc;

    if ( iframe.getAttribute( 'src' ) )
        iframe.src = newSrc;
});
